<template>
  <div>
    <template v-if="isStampRally">
      <div class="footer">
        <FaceAnimation
          :url="masterSheet.content.sheet_animation_image_url || String()"
          :is-sheet="true"
          :is-stamp-rally="true"
        />
      </div>
      <SFaceCheckinDateTime :stamped_at="frame.stamped_at" />
    </template>

    <template v-else-if="isCountDownActive">
      <div class="footer">
        <FaceCountDown :count-down="countDown" />
        <FaceAnimation
          :url="masterSheet.content.sheet_animation_image_url || String()"
          :is-sheet="true"
        />
      </div>
      <SFaceCheckinDateTime :stamped_at="frame.stamped_at" />
    </template>

    <template v-else>
      <SFaceUsedLowerDefaultContent class="used-lower-default-content" />
      <SFaceUsedLowerDefaultFooter
        class="used-lower-default-footer"
        :stamped-at="frame.stamped_at"
      />
    </template>
  </div>
</template>

<script>
import { onMounted, computed, ref } from "vue";
import { useStore } from "vuex";

import myTicketsCommonService from "@/services/common/myTickets";
import { checkIsStampRally } from "@/services/masterBook/methods/checkIsStampRally";
import { checkIsCountDownActive } from "@/services/sheet/methods/checkIsCountDownActive";

export default {
  name: "TheSheetUsedLower",
  setup() {
    const store = useStore();

    const frame = computed(() => store.getters["ticketing/frame"]);
    const masterSheet = computed(() => store.getters["ticketing/masterSheet"]);
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);

    const countDown = ref(null);

    const isStampRally = computed(() =>
      checkIsStampRally(
        masterBook.value?.content?.description_json?.MbDisplayType
      )
    );

    const isCountDownActive = computed(() =>
      checkIsCountDownActive(countDown.value)
    );

    onMounted(() => {
      updateCountDown();
      setInterval(() => updateCountDown(), 1 * 1000);
    });

    const updateCountDown = () => {
      if (frame.value.stamped_at) {
        const limit = myTicketsCommonService.getCountDownLimit(
          frame.value.stamped_at,
          masterSheet.value.content.description_json.FaceCountDown
        );

        countDown.value = myTicketsCommonService.getCountDown(limit);
      }
    };

    return {
      masterSheet,
      frame,
      countDown,
      isStampRally,
      isCountDownActive,
    };
  },
};
</script>

<style lang="scss" scoped>
.used-lower-default-content {
  position: absolute;
  width: 100%;
  height: 33vh;
  bottom: 0;
}

.used-lower-default-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
}
</style>
